import { Box, Flex } from "@acko-tech/building-blocks.ui.common";
import { Text } from "@acko-tech/building-blocks.ui.typography";
import styled from "styled-components";


interface PremiumDetailsContainerProps {
  applyMarginAdjustment?: boolean;
}

interface StyledBoxProps {
  mStyles?: string;
}

export const PremiumDetailsContainer = styled.div<PremiumDetailsContainerProps>`
  display: flex;
  flex-direction: column;
  &:not(:last-child) {
  border-bottom: 1px solid #e7e7f0;
  width: 92%;
  }
  ${(props) =>
    props.applyMarginAdjustment &&
    `
    &:first-child {
      margin-top: -12px;
    }
    &:last-child {
      margin-bottom: -12px;
    }
  `}
`;

export const StyledBox = styled(Box)<StyledBoxProps>`
  @media (max-width: 768px) {
    ${(props) => props.mStyles}
  }
`;

export const PremiumdetailWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 1rem 0.5rem 1rem 0;
`;

export const PremiumDetailHeading = styled(Text)`
  color: #040222;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
`;

export const PremiumDetailItem = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

export const PremiumDetailLabel = styled.div`
  align-items: flex-start;
  display: flex;
  flex-direction: column;
`;

export const PremiumDetailType = styled.div`
  color: #5b5675;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
`;

export const PremiumDetailTag = styled.div`
  display: flex;
  padding: 2px 16px 2px 8px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 49px;
  background: linear-gradient(
    91deg,
    rgba(74, 222, 128, 0.32) 0.48%,
    rgba(74, 222, 128, 0) 89.37%
  );
  color: #0a562a;
  font-family: 'Euclid Circular B', 'Inter', sans-serif;
  font-size: 10px;
  font-style: normal;
  font-weight: 500;
  line-height: 14px;
  margin-top: 2px;
  width: fit-content;
  white-space: nowrap;
`;

interface PremiumDetailValueProps {
  isDiscount?: boolean;
}

export const PremiumDetailValue = styled.div<PremiumDetailValueProps>`
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  color: ${(props) => (props.isDiscount ? "#0FA457" : " #040222")};
  font-variant-numeric: tabular-nums;
`;

export const PremiumDetailAmount = styled.div`
  display: flex;
  align-items: baseline;
  gap: 4px;
`;

export const StrikeThroughPremiumDetailValue = styled.del`
  color: #5b5675;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  font-variant-numeric: tabular-nums;
`;

export const GrossPremiumText = styled(Text)`
  color: #040222;
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
`;

export const GrossPremiumCueText = styled(Text)`
  color: #5b5675;
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
`;

export const GrossPremiumAmount = styled(Text)`
  color: #040222;
  font-size: 18px;
  font-weight: 600;
  line-height: 24px;
  padding-right: 2rem;
`;
